import { Validator } from '@vista-digital/validator';
import { notificationListEventsValidator } from './events';
export const notificationListPropsValidator = Validator.object({
    events: notificationListEventsValidator
});
export const defaultNotificationListProps = {
    events: {}
};
//# sourceMappingURL=props.js.map